@if (form) {
    Requirements:
    <ul>
        <li>Cannot be the same as your User Name.</li>
        <li>Must be at least 8 characters long.</li>
        <li>Must contain at least one number, letter and special character.</li>
        <li>Cannot match your last 3 passwords.</li>
    </ul>
    @if (showCurrent) {
        <div class="mb-4">
            <label class="control-label col-md-2" for="current">
                Current:
            </label>
            <div class="col-md-10">
                <input type="password"
                       id="current"
                       name="current"
                       class="form-control"
                       [ngClass]="{ 'isInvalid': current.touched && current.invalid }"
                       placeholder="Current Password"
                       [formControl]="current"
                       required>
                @if (current.touched && current.errors) {
                    <div>
                        <ul>
                            @if (current.errors.minlength) {
                                <li>This entry is too short.</li>
                            }
                            @if (current.errors.required) {
                                <li>An entry is required.</li>
                            }
                            @if (current.errors.incorrect) {
                                <li>Incorrect password entered.</li>
                            }
                        </ul>
                    </div>
                }
            </div>
        </div>
    }
    <div class="mb-4">
        <label class="control-label col-md-2" for="new">
            New:
        </label>
        <div class="col-md-10">
            <input type="password"
                   id="new"
                   name="new"
                   class="form-control"
                   [ngClass]="{ 'is-invalid': newPassword.touched && newPassword.invalid }"
                   placeholder="New Password"
                   [formControl]="newPassword"
                   required>
            @if (newPassword.touched && newPassword.invalid) {
                <div>
                    <ul>
                        @if (newPassword.errors.minlength) {
                            <li>This entry is too short.</li>
                        }
                        @if (newPassword.errors.required) {
                            <li>An entry is required.</li>
                        }
                        @if (newPassword.errors.pattern) {
                            <li>Does not have at least one special character and one number.</li>
                        }
                        @if (newPassword.errors.sdDoesNotMatch) {
                            <li>Password cannot be the same as your user name.</li>
                        }
                        @if (newPassword.errors.alreadyUsed) {
                            <li>Password has already been used.</li>
                        }
                    </ul>
                </div>
            }
        </div>
    </div>
    <div class="mb-4">
        <label class="control-label col-md-2" for="confirm">
            Confirm:
        </label>
        <div class="col-md-10">
            <input type="password"
                   id="confirm"
                   name="confirm"
                   class="form-control"
                   [ngClass]="{ 'is-invalid': confirm.touched && confirm.invalid }"
                   placeholder="Confirm Password"
                   [formControl]="confirm"
                   required>
            @if (confirm.touched && confirm.invalid) {
                <div>
                    <ul>
                        @if (confirm.errors.sdMustMatch) {
                            <li>Does not match new password.</li>
                        }
                        @if (confirm.errors.required) {
                            <li>An entry is required.</li>
                        }
                    </ul>
                </div>
            }
        </div>
    </div>
    <p>
        Note: Once you change your password you will be logged out.
    </p>
}
